import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRefresh } from '@fortawesome/free-solid-svg-icons'

import ListTopBar from '../../../components/ListTopBar'

import OrdersTable from './OrdersTable'

import { getOrders } from '../services'
import { handleError, parsePagination } from '../../../helpers'

export default function OrdersList({ reloadOrders, setReloadOrders }) {
	const user = useSelector(state => state.auth.user)
	const [orders, setOrders] = useState(null)
	const [filterType, setFilterType] = useState('sku')
	const [filterValue, setFilterValue] = useState('')
	const [pagination, setPagination] = useState({page: 1, per_page: 5, total: 0})

	useEffect(() => {
		!orders && getOrders({
			...pagination,
			[`filter[${filterType}]`]: filterValue,
			'filter[supplier_id]': user.id,
			include: 'orderDetails',
			sort: '-registered_at'
		})
			.then(res => {
				setOrders(res.data.data)
				setPagination(parsePagination(res))
			})
			.catch(error => handleError(error))
	}, [ orders, pagination, filterType, filterValue, user ])

	useEffect(() => {
		if (reloadOrders) {
			setOrders(null)
			setReloadOrders(false)
		}
	}, [reloadOrders, setReloadOrders])

	return (
		<React.Fragment>
			<ListTopBar 
				filterType={filterType}
				setFilterType={setFilterType}
				filterValue={filterValue}
				setFilterValue={setFilterValue}
				reload={() => setOrders(null)}
				options={[
					{ label: 'Buscar por consecutivo', value: 'sku' },
					{ label: 'Buscar por tipo de orden', value: 'order_type' },
				]}
				ctaText={<FontAwesomeIcon icon={faRefresh} />}
				handleCtaClick={() => setOrders(null)}
			/>
			<OrdersTable 
				orders={orders}
				reload={() => setOrders(null)}
				pagination={pagination}
				setPagination={setPagination}
			/>
		</React.Fragment>
	)
}